import { getRegionOptions } from '../constants';
import i18n from '../context/language/i18n';
import { isZipcode } from './password-validation';

// 주소에서 지역 추출 함수 (한국어 주소와 매칭하기 위해 ko 로케일로 비교)
export const getRegionFromAddress = (address) => {
    if (!address) return '';
    const addressFirst = address.split(' ')[0] || '';
    const t = i18n.getFixedT ? i18n.getFixedT('ko') : (k) => k;
    for (const region of getRegionOptions('ko')) {
        const labelKo = t(region.label);
        const shortLabelKo = t(region.shortLabel);
        if (addressFirst.includes(labelKo) || addressFirst.includes(shortLabelKo)) {
            return region.value;
        }
    }
    return '';
};

// 주소 검색 함수 (우편번호 또는 주소 일부로 검색 가능)
export const searchAddress = async (searchQuery, country = 'ko', onSuccess) => {
    if (!searchQuery || searchQuery.trim().length < 2) return;

    const query = searchQuery.trim();

    try {
        // 대한민국인 경우 카카오 주소 검색 API 사용
        if (country === 'ko') {
            const kakaoApiKey = process.env.REACT_APP_KAKAO_REST_API_KEY;

            if (kakaoApiKey) {
                try {
                    // 카카오 주소 검색 API 호출 (우편번호 또는 주소 일부로 검색 가능)
                    const response = await fetch(`https://dapi.kakao.com/v2/local/search/address.json?query=${encodeURIComponent(query)}`, {
                        headers: {
                            'Authorization': `KakaoAK ${kakaoApiKey}`
                        }
                    });

                    const data = await response.json();

                    if (response.ok) {
                        if (data.documents && data.documents.length > 0) {
                            const addressInfo = data.documents[0];

                            // 주소 정보 파싱
                            // 도로명 주소가 있으면 도로명 주소 사용, 없으면 지번 주소 사용
                            const roadAddress = addressInfo.road_address;
                            const address = roadAddress
                                ? roadAddress.address_name || ''
                                : addressInfo.address?.address_name || '';

                            // 카카오 API는 y가 위도, x가 경도
                            const latitude = addressInfo.y || (roadAddress?.y) || (addressInfo.address?.y) || '';
                            const longitude = addressInfo.x || (roadAddress?.x) || (addressInfo.address?.x) || '';

                            // 우편번호 추출 (도로명 주소 우선, 없으면 지번 주소, 둘 다 없으면 빈 문자열)
                            const zipcode = roadAddress?.zone_no
                                || addressInfo.address?.zone_no
                                || addressInfo.zone_no
                                || '';

                            const region = getRegionFromAddress(address);

                            // 성공 콜백 호출
                            if (onSuccess) {
                                onSuccess({
                                    zipcode,
                                    address,
                                    latitude,
                                    longitude,
                                    region
                                });
                            }
                            return;
                        } else {
                            // 카카오 API에서 결과가 없는 경우 (우편번호만 입력한 경우 등)
                            console.log('카카오 API에서 검색 결과가 없습니다. Fallback으로 넘어갑니다.');
                            // Fallback으로 넘어감
                        }
                    } else {
                        // 에러 응답 처리
                        console.error('카카오 주소 검색 API 에러:', data);
                        console.error('카카오 API 에러:', data.message || data);

                        // 에러 발생 시 fallback으로 넘어감
                    }
                } catch (kakaoError) {
                    console.error('카카오 주소 검색 API 호출 실패:', kakaoError);
                    // 카카오 API 실패 시 기존 API로 fallback
                }
            } else {
                console.warn('카카오 API 키가 설정되지 않았습니다. 환경변수 REACT_APP_KAKAO_REST_API_KEY를 설정해주세요.');
            }
        }

        // 대한민국이 아니거나 카카오 API를 사용할 수 없는 경우 OpenStreetMap Nominatim API 사용
        // 우편번호 형식인 경우에만 검색 (숫자 5-6자리)
        if (isZipcode(query)) {
            const response = await fetch(`https://nominatim.openstreetmap.org/search?postalcode=${query}&country=South Korea&format=json&addressdetails=1&limit=1`);

            if (response.ok) {
                const data = await response.json();

                if (data && data.length > 0) {
                    const addressInfo = data[0];

                    // 주소 정보 파싱
                    const address = addressInfo.display_name || '';
                    const latitude = addressInfo.lat || '';
                    const longitude = addressInfo.lon || '';
                    const region = getRegionFromAddress(address);

                    // 성공 콜백 호출
                    if (onSuccess) {
                        onSuccess({
                            zipcode: query, // OpenStreetMap은 우편번호를 직접 사용
                            address,
                            latitude,
                            longitude,
                            region
                        });
                    }
                }
            }
        }
    } catch (error) {
        console.error('주소 검색 실패:', error);
    }
};

